import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

export function customerGroupList(data) {
  return axios.post(`${base.url}/business/customerGroup/list`, qs.stringify(data))
}
export function customerGroupAddOrUpdate(data) {
  return axios.post(`${base.url}/business/customerGroup/addOrUpdate`, JSON.stringify(data),
    { headers: { 'Content-Type': 'application/json' } })
}
export function customerGroupDeleteBatchIds(ids) {
  return axios.post(`${base.url}/business/customerGroup/deleteBatchIds`, qs.stringify({ ids }))
}
export function customerGroupStatus(ids, status) {
  return axios.post(`${base.url}/business/customerGroup/status`, qs.stringify({ ids, status }))
}
export function customerGroupPermissions(groupId) {
  return axios.post(`${base.url}/business/customerGroup/permissions`, qs.stringify({ groupId }))
}
export function customerGroupSetDefault(id) {
  return axios.post(`${base.url}/business/customerGroup/setDefault`, qs.stringify({ id }))
}
